import React, { useState } from "react";
import classes from "./analyticsMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Carousel from "react-elastic-carousel";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  PaymentIconRed,
  UserIconRed,
  StarIconRed,
  WorkingHoursRed,
  ArrowUpRightBlue,
  GraphBlueIcon,
  GraphGrayIcon,
  BarBlueIcon,
  BarGrayIcon,
  FilterIconBlack,
  CalendarIconBlue,
  CalendarIconGray,
  ListIconBlue,
  ListIconGray,
} from "../../../../constant/imagePath";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";
import { ReactSVG } from "react-svg";
import { ButtonGroup } from "../../../../stories/ButtonGroup/ButtonGroup";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import moment from "moment";
import StatisticModal from "../../../../components/Modals/CoachFlow/Insights/StatisticModal/StatisticModal";
import InsightFilterModal from "../../../../components/Modals/CoachFlow/Insights/InsightFilterModal/InsightFilterModal";
import StatisticMobileModal from "../../../../components/Modals/CoachFlow/Insights/StatisticMobileModal/StatisticMobileModal";

export const AnalyticsMobile = () => {
  const [graphView, setGraphView] = useState("bar");
  const [statsModal, setStatsModal] = useState(false);

  const [filterModal, setFilterModal] = useState(false);

  const [filterLocation, setFilterLocation] = useState();

  const [statisticsFilterLocation, setStatisticsFilterLocation] = useState();
  const [statisticsFilterSport, setStatisticsFilterSport] = useState();
  const [statisticsFilterSeason, setStatisticsFilterSeason] = useState();

  const summary = [
    {
      title: "Income this week",
      img: PaymentIconRed,
      price: 500,
    },
    {
      title: "Hours worked",
      img: WorkingHoursRed,
      price: 22,
    },
    {
      title: "No. of sessions",
      img: StarIconRed,
      price: 24,
    },
    {
      title: "No. of students",
      img: UserIconRed,
      price: 5,
    },
  ];
  const settings = {
    showArrows: false,
    itemsToShow: 1,
    itemsToScroll: 1,
  };

  const labels = [
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
  ];
  const options = {
    scales: {
      y: {
        ticks: {
          callback: function (value) {
            return "$" + value;
          },
          stepSize: 100,
        },
        min: 0,
        max: 400,
        position: "left",
        type: "linear",
      },
      y1: {
        ticks: {
          callback: function (value) {
            return value + "h";
          },
          stepSize: 2,
        },
        min: 0,
        max: 8,
        position: "right",
        type: "linear",
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    categoryPercentage: 0.3,
    barPercentage: 0.5,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Income",
        data: [100, 200, 300, 380, 350, 250, 150],
        backgroundColor: `${Colors.errorColor}`,
        borderColor: `${Colors.errorColor}`,
        borderRadius: 14,
        yAxisID: "y",
      },
      {
        label: "Hours",
        data: [1, 5, 2, 3, 6, 4, 7],
        backgroundColor: `${Colors.mainBlue}`,
        borderColor: `${Colors.mainBlue}`,
        borderRadius: 14,
        yAxisID: "y1",
      },
    ],
  };
  return (
    <div>
      <style>{`
            .${classes.insightCarousel} .rec-dot {
                width: 4px;
                height: 4px;
                background-color: ${Colors.neutralShadesOfGainsboro};
                box-shadow:none;
            }
            .${classes.insightCarousel} .rec-dot_active {
                background-color: ${Colors.neutralShadesOfNero};
            }
        `}</style>
      <div className={[classes.mb40].join(" ")}>
        <Carousel {...settings} className={[classes.insightCarousel]}>
          {summary.map((item, i) => {
            return (
              <div
                style={{
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
                className={[classes.AnalyticsCarouselDiv].join(" ")}
              >
                <p
                  style={{
                    ...Fonts.otherSemiBold,
                    color: Colors.neutralShadesOfDimGray,
                    fontSize: "16px",
                    lineHeight: "20px",
                  }}
                  className={[classes.mb4].join(" ")}
                >
                  {item.title}
                </p>
                <div className={[classes.dflex, classes.itemscenter].join(" ")}>
                  <ReactSVG
                    src={item.img}
                    className={[classes.AnalyticsCarouselSectionImg].join(" ")}
                  />
                  <h4
                    className={[classes.ml16].join(" ")}
                    style={{
                      ...Fonts.h4,
                      color: Colors.neutralShadesOfNero,
                      fontSize: "26px",
                    }}
                  >
                    ${item.price}
                  </h4>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
      <div>
        <div className={[classes.btngroupAndDateDiv].join(" ")}>
          <div className={[classes.dflex].join(" ")}>
            <Button
              label=""
              size="Large"
              icon={FilterIconBlack}
              customStyle={{
                backgroundColor: Colors.neutralShadesOfWhiteSmoke,
                border: "none",
              }}
              onClick={() => setFilterModal(true)}
            />
            <ButtonGroup
              btnIcon1={graphView === "bar" ? CalendarIconBlue : CalendarIconGray}
              btnIcon2={graphView === "line" ? ListIconBlue : ListIconGray}
              onClick1={() => setGraphView("bar")}
              onClick2={() => setGraphView("line")}
              customStyle={{
                backgroundColor: Colors.neutralShadesOfWhiteSmoke,
                border: "none",
                marginLeft: "12px",
              }}
            />
          </div>
          <div style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
            {moment().format("MMM DD")}-
            {moment().format("MMM DD")}
          </div>
        </div>

        {graphView === "bar" && (
          <div className={[classes.overflowX].join(" ")}>
            <div
              className={[classes.graphDiv].join(" ")}
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <Bar options={options} data={data} />
            </div>
          </div>
        )}

        {graphView === "line" && (
          <div className={[classes.overflowX].join(" ")}>
            <div
              className={[classes.graphDiv].join(" ")}
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <Line options={options} data={data} />
            </div>
          </div>
        )}

        <div className={[classes.dflex, classes.contentcenter].join(" ")}>
          <div>
            <span
              style={{ backgroundColor: Colors.errorColor }}
              className={[classes.labelBox].join(" ")}
            />
            <span style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
              Income
            </span>
          </div>
          <div className={[classes.ml40].join(" ")}>
            <span
              style={{ backgroundColor: Colors.mainBlue }}
              className={[classes.labelBox].join(" ")}
            />
            <span style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
              Hours
            </span>
          </div>
        </div>

        <div className={[classes.lastDiv].join(" ")}>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
            Want to learn more about how other sports work on Lytesnap?
          </p>
          <LinkButtonWithIcon
            text={"Check out seasons statistic"}
            customStyle={{
              ...Fonts.b2,
              fontSize: "16px",
              lineHeight: "16px",
              marginLeft: "10px",
            }}
            rightIcon={ArrowUpRightBlue}
            primary={true}
            onClick={() => setStatsModal(true)}
          />
        </div>

        <StatisticMobileModal
          location={statisticsFilterLocation}
          setLocation={setStatisticsFilterLocation}
          sport={statisticsFilterSport}
          setSport={setStatisticsFilterSport}
          season={statisticsFilterSeason}
          setSeason={setStatisticsFilterSeason}
          show={statsModal}
          setShow={setStatsModal}
        />
        <InsightFilterModal
          show={filterModal}
          setShow={setFilterModal}
          location={filterLocation}
          setLocation={setFilterLocation}
        />
      </div>
    </div>
  );
};
